import React from 'react';
import PropTypes from 'prop-types';
import ContextMenuSlot from './ContextMenuSlot';
import ContextMenuPachi from './ContextMenuPachi';
import ContextMenuSort from './ContextMenuSort';
import WrapMenuTabVer from '../common/WrapMenuTabVer';
import Wrapper from './Wrapper';
import Loading from '../common/Loading';
import LoadingResize from '../common/LoadingResize';

/**
 * BodyTable
 */
class BodyTable extends React.Component {

  componentDidMount() {
    this.props.actions.onMounted();
  }

  render() {
    let context;
    let sortContext;
    if (this.props.data.error == null) {
      // スロットの場合、段階設定別集計を表示する
      if (this.props.data.pskubun == 1) {
        context = <ContextMenuSlot />;
      } else {
        context = <ContextMenuPachi />;
      }

      if (this.props.data.dayFlg == '1') {
        sortContext = <ContextMenuSort />;
      }
    }

    return (
      <div className="fix_height">
        {context}
        {sortContext}
        <WrapMenuTabVer />
        <Wrapper data={this.props.data} actions={this.props.actions} comactions={this.props.comactions} />
        <Loading />
        <LoadingResize />
      </div>
    );
  }
}

BodyTable.propTypes = {
  data: PropTypes.any.isRequired,
  actions: PropTypes.any.isRequired,
  comactions: PropTypes.any.isRequired
};

export default BodyTable;
